import { z } from 'zod';
import { TradingMode } from '@shared/types';

export const MarketConfigInputSchema = z.object({
  exchangeId: /*z.nativeEnum(ExchangeId)*/ z.string().optional(),
  testnet: z.boolean().default(false),
  symbol: z.string(),
  useExchangeData: z.boolean().optional(),
  simulation: z.boolean().optional(),
  tradingMode: z.nativeEnum(TradingMode)
});

export type MarketConfigInput = z.infer<typeof MarketConfigInputSchema>;
